"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDateTimeString = void 0;
const toDateTimeString = (source) => {
    if (!source || typeof source === 'string') {
        return source;
    }
    if (source.toISOString) {
        return source.toISOString();
    }
    if (source.toISO) {
        return source.toISO();
    }
    throw new Error(`Not identified object detected ${source}`);
};
exports.toDateTimeString = toDateTimeString;
//# sourceMappingURL=to-date-time-string.js.map